/**
 * 服务能力导航树 Mock 数据
 */
import type { NavTreeNode } from '@/types/common';
import { ROUTE_PATHS } from '@/utils/constants';

/** 服务能力导航树 Mock 数据 */
export const navTreeMockData: NavTreeNode[] = [
  {
    id: 'tech-service',
    label: '技术服务能力',
    icon: 'build',
    route: '',
    defaultExpanded: true,
    children: [
      {
        id: 'tech-certifications',
        label: '技术认证资质',
        icon: 'verified',
        route: ROUTE_PATHS.TECH_CERTIFICATIONS,
      },
      {
        id: 'capability-matrix',
        label: '服务能力矩阵',
        icon: 'grid',
        route: ROUTE_PATHS.CAPABILITY_MATRIX,
      },
      {
        id: 'case-library',
        label: '典型案例库',
        icon: 'folder',
        route: ROUTE_PATHS.CASE_LIBRARY,
      },
      {
        id: 'engineer-team',
        label: '工程师团队',
        icon: 'group',
        route: ROUTE_PATHS.ENGINEER_TEAM,
      },
    ],
  },
  {
    id: 'solution-capability',
    label: '解决方案能力',
    icon: 'lightbulb',
    route: '',
    defaultExpanded: true,
    children: [
      {
        id: 'solution-portfolio',
        label: '方案产品组合',
        icon: 'category',
        route: ROUTE_PATHS.SOLUTION_PORTFOLIO,
      },
      {
        id: 'solution-design',
        label: '方案设计能力',
        icon: 'design_services',
        route: ROUTE_PATHS.SOLUTION_DESIGN,
      },
      {
        id: 'poc-resources',
        label: '演示与POC资源',
        icon: 'science',
        route: ROUTE_PATHS.POC_RESOURCES,
      },
      {
        id: 'industry-solutions',
        label: '行业化解决方案',
        icon: 'business',
        route: ROUTE_PATHS.INDUSTRY_SOLUTIONS,
      },
    ],
  },
  {
    id: 'compliance',
    label: '资质与合规',
    icon: 'gavel',
    route: '',
    defaultExpanded: true,
    children: [
      {
        id: 'compliance-certificates',
        label: '合规证书管理',
        icon: 'card_membership',
        route: ROUTE_PATHS.COMPLIANCE_CERTIFICATES,
      },
      {
        id: 'quality-audit',
        label: '服务质量审核',
        icon: 'fact_check',
        route: ROUTE_PATHS.QUALITY_AUDIT,
      },
      {
        id: 'sla-standards',
        label: 'SLA承诺标准',
        icon: 'handshake',
        route: ROUTE_PATHS.SLA_STANDARDS,
      },
      {
        id: 'upgrade-application',
        label: '资质升级申请',
        icon: 'trending_up',
        route: ROUTE_PATHS.UPGRADE_APPLICATION,
      },
      {
        id: 'health-dashboard',
        label: '健康度看板',
        icon: 'favorite',
        route: ROUTE_PATHS.HEALTH,
      },
      {
        id: 'mdf-application',
        label: 'MDF申请',
        icon: 'payments',
        route: ROUTE_PATHS.MDF,
      },
    ],
  },
  {
    id: 'learning-center',
    label: '学习中心',
    icon: 'school',
    route: '',
    defaultExpanded: true,
    children: [
      {
        id: 'learning-materials',
        label: '学习资料',
        icon: 'menu_book',
        route: ROUTE_PATHS.LEARNING_MATERIALS,
      },
      {
        id: 'exam-bank',
        label: '线上试题库',
        icon: 'quiz',
        route: ROUTE_PATHS.EXAM_BANK,
      },
      {
        id: 'course-management',
        label: '课程管理',
        icon: 'cast_for_education',
        route: ROUTE_PATHS.COURSE_MANAGEMENT,
      },
      {
        id: 'learning-progress',
        label: '学习情况',
        icon: 'analytics',
        route: ROUTE_PATHS.LEARNING_PROGRESS,
      },
    ],
  },
];
